import ptTranslations from './pt';
import enTranslations from './en';
import deTranslations from './de';

export const resources = {
  pt: {
    translation: ptTranslations,
  },
  en: {
    translation: enTranslations,
  },
  de: {
    translation: deTranslations,
  },
};
